import { AUTHENTICATED_USER } from "constants/keys";
import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

const PrivateRoute = () => {
  const authenticated_user = localStorage.getItem(AUTHENTICATED_USER);
  const { slug } = useParams();

  if (!authenticated_user) {
    // Redirect user to merchant-specific login
    return <Navigate to={`/${slug}`} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
